export default function YoutubeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_1273_25069)">
        <path
          d="M12.0765 3.12354H12.21C13.443 3.12804 19.6905 3.17304 21.375 3.62604C21.8842 3.76429 22.3483 4.03377 22.7207 4.40755C23.0932 4.78133 23.361 5.24631 23.4975 5.75604C23.649 6.32604 23.7555 7.08054 23.8275 7.85904L23.8425 8.01504L23.8755 8.40504L23.8875 8.56104C23.985 9.93204 23.997 11.216 23.9985 11.4965V11.609C23.997 11.9 23.9835 13.271 23.8755 14.699L23.8635 14.8565L23.85 15.0125C23.775 15.8705 23.664 16.7225 23.4975 17.3495C23.3615 17.8595 23.0938 18.3247 22.7212 18.6985C22.3487 19.0724 21.8844 19.3417 21.375 19.4795C19.635 19.9475 13.0215 19.9805 12.105 19.982H11.892C11.4285 19.982 9.5115 19.973 7.5015 19.904L7.2465 19.895L7.116 19.889L6.8595 19.8785L6.603 19.868C4.938 19.7945 3.3525 19.676 2.622 19.478C2.11273 19.3403 1.6486 19.0712 1.27609 18.6976C0.903575 18.3241 0.63577 17.8592 0.4995 17.3495C0.333 16.724 0.222 15.8705 0.147 15.0125L0.135 14.855L0.123 14.699C0.0489714 13.6826 0.0079498 12.6641 0 11.645L0 11.4605C0.003 11.138 0.015 10.0235 0.096 8.79354L0.1065 8.63904L0.111 8.56104L0.123 8.40504L0.156 8.01504L0.171 7.85904C0.243 7.08054 0.3495 6.32454 0.501 5.75604C0.63704 5.24611 0.904743 4.7809 1.27727 4.40706C1.6498 4.03322 2.11405 3.76387 2.6235 3.62604C3.354 3.43104 4.9395 3.31104 6.6045 3.23604L6.8595 3.22554L7.1175 3.21654L7.2465 3.21204L7.503 3.20154C8.93056 3.1556 10.3587 3.13009 11.787 3.12504H12.0765V3.12354ZM9.6 7.93854V15.1655L15.8355 11.5535L9.6 7.93854Z"
          fill="white"
          fillOpacity="0.75"
        />
      </g>
      <defs>
        <clipPath id="clip0_1273_25069">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
